import {AttributeLink, AttributeSetup} from '@acng/frontend-stargazer';
import {compile} from '../service/template.js';
import {onClick} from '../../layout/service/worker.js';
import {getLocalAmateur} from '../../amateurPool/context/amateur.js';
import {put} from 'acng/core/service/backend.js';
import {ENUM, guard} from '@acng/frontend-rubicon';

/**
 * > By definition, the vote refers to the "matchmaker_image". **Make sure** this
 * > image is visible next to the button.
 *
 * @group DOM Attribute
 */
const name = 'onclick-vote';

AttributeSetup(name, () => {
  AttributeLink(name, (element, state) => {
    onClick(element, async () => {
      ASSERT: guard(state, STATE, `[${name}] value`);
      const {id, matchmaker_image: imageId} = getLocalAmateur(element);

      await put(`hotornot/${id}`, {state, imageId}, element);
    });
  });

  return compile;
});

const STATE = /* @__PURE__ */ ENUM(
  /**
   * @type {const}
   */ (['hot', 'not']),
);

export {name as ONCLICK_VOTE};
